import React from 'react';

import GoogleWhiteLogo from 'Shared/components/Logos/GoogleWhiteLogo';

import CircleSignUpButton from '../CircleSignUpButton/CircleSignUpButton';
import { useApp } from 'Shared/utils/hooks/use-app';

function GoogleButton() {
  const {
    app: {
      routes: { googleSignUpUrl },
    },
  } = useApp();

  return (
    <CircleSignUpButton
      color="#3A75CD"
      logo={<GoogleWhiteLogo width="22" height="22" className="m-auto" />}
      label="Sign up with Google"
      signUpUrl={googleSignUpUrl}
    />
  );
}

export default GoogleButton;
